/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { useLazyQuery } from '@apollo/client';
import ReactSelect from 'components/Fields/ReactSelect';
import { Field } from 'formik';
import { STATES_BY_COUNTRY } from 'pages/MarketListing/MarketListingGraphQL';
import Loader from 'components/common/Loader';

const StateField = ({
  name,
  label,
  id,
  countryId,
  required = false,
  ...rest
}) => {
  const [statesByCountry, { data, loading, error }] = useLazyQuery(
    STATES_BY_COUNTRY,
    {
      fetchPolicy: 'network-only',
    },
  );

  useEffect(() => {
    if (countryId)
      statesByCountry({
        variables: {
          country: countryId,
        },
      });
  }, [countryId]);

  if (loading) return <Loader size="sm" />;
  if (error) return `There is an error on this page : ${error.message} `;

  return (
    <div>
      <Field
        id={id}
        label={label}
        name={name}
        type="select"
        component={ReactSelect}
        data={data?.statesByCountry || []}
        keys={{ id: 'id', label: 'label' }}
        getOptionValue={(option) => option.id}
        getOptionLabel={(option) => option.stateName}
        required={required}
        {...rest}
        // onChange={(value) => {
        //   setFieldValue(name, value);
        //   setFieldValue(`addresses[${0}].city`, { id: '', label: '' });
        // }}
      />
    </div>
  );
};

export default StateField;
